var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-notifications"},[_c('transition-group',{attrs:{"name":"translate-from-right"}},_vm._l((_vm.notifications),function(notification){return _c('NotificationBar',{key:notification.id,attrs:{"notification":notification}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }